<script>
    export let timestamp;
</script>
<dl>
	<dt>Last Update</dt>
	<dd>{timestamp}</dd>
</dl>
<style>
    dl {
        justify-content: flex-end;
    }

    dt, dd {
        font-weight: 300;
        padding:0;
        margin: 0 .25em;
    }

    dt {
        flex-grow: 0;
    }

    dd {
        flex-grow: 0;
    }
</style>